module.exports = __webpack_public_path__ + "static/media/ME_mobile_anim.74af47b9.mp4";